<span><ng-content></ng-content></span>



// WEBPACK FOOTER //
// ./node_modules/@cicero/webui/lib/core/pagetip/pagetip.component.html